import { SearchOutlined } from "@ant-design/icons";
import { Form, Input, Select } from "antd";
import FilterDate from "components/CustomFilterMenu/FilterDate";
import { CustomPaginationPrevNext } from "components/CustomPaginationPrevNext";
import CustomTable from "components/CustomTable";
import { FiltersTag } from "../../../components/FiltersTag";
import TablesList from "../Tables/TablesList";
import useList from "./useList";

function ListBySerial() {
  const {
    valueFormSelectCity,
    loading,
    data,
    branchesID,
    paginationData,
    params,
    staffs,
    optionExportRadio,
    handleChangeTable,
    onSearch,
    onChangeBranchesId,
    handleRemoveFilterTag,
    handleFilter,
    handlePrevNextPage,
    handleChangeDate,
    propsFilterCreated,
  } = useList();

  const { BY_SERIAL_COLUMN } = TablesList({ params: params, handleFilter, propsFilterCreated });

  return (
    <div className="list-by-serial-export-notes-page">
      <Form name="basic" autoComplete="off" style={{ display: "flex", gap: 8 }}>
        <FilterDate title={"Ngày tạo"} onChangeDate={handleChangeDate} />
        <div style={{ width: "100%" }}>
          <Form.Item style={{ marginBottom: 0 }}>
            <Input
              placeholder={"Tìm kiếm theo số serial/ IMEI"}
              onChange={onSearch}
              prefix={<SearchOutlined />}
              style={{ maxWidth: 500 }}
              allowClear
            />
          </Form.Item>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <Form.Item style={{ marginBottom: 0 }}>
            <Select options={valueFormSelectCity} onChange={(e) => onChangeBranchesId(e)} value={branchesID} />
          </Form.Item>
        </div>
      </Form>
      <FiltersTag
        staffOptions={staffs}
        params={params}
        optionExportRadio={optionExportRadio}
        handleRemoveFilterTag={handleRemoveFilterTag}
      />
      <CustomTable
        loading={loading}
        columns={BY_SERIAL_COLUMN}
        dataSource={data}
        rowKey={(record) => record?.id}
        onChange={handleChangeTable}
      />
      {paginationData && (
        <CustomPaginationPrevNext handlePrevNextPage={handlePrevNextPage} paginationData={paginationData} />
      )}
    </div>
  );
}

export default ListBySerial;
